import { useMutation } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

export function useSocialPostMutations(agencyId: string) {
  const { post, del } = useApiHelper();
  const { saveHandlers, deleteHandlers } =
    useDefaultCRUDHandlers("Social Post");

  const create = useMutation(
    (postData: any) => post(`/socialpost/${agencyId}`, postData),
    {
      ...saveHandlers,
    }
  );

  const remove = useMutation((postId: string) => del(`/socialpost/${postId}`), {
    ...deleteHandlers,
  });

  return {
    create,
    remove,
  };
}
